import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "col-md-6 pl-md-4" }
const _hoisted_2 = { class: "pt-3" }
const _hoisted_3 = { class: "tab-content" }
const _hoisted_4 = {
  class: "tab-pane fade show active",
  id: "billing-accounts",
  role: "tabpanel",
  "aria-labelledby": "tab-team-own"
}
const _hoisted_5 = { class: "list-group" }
const _hoisted_6 = ["data-refid", "onClick"]
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-sm-4 col-lg-3 d-flex flex-sm-column align-items-center justify-content-center" }
const _hoisted_9 = { class: "d-inline-block d-sm-block m-2" }
const _hoisted_10 = { class: "col-sm-8 col-lg-9 d-flex flex-column" }
const _hoisted_11 = { class: "d-flex" }
const _hoisted_12 = { class: "flex-fill" }
const _hoisted_13 = { class: "ml-1" }
const _hoisted_14 = { class: "dropdown-menu" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "help-text" }
const _hoisted_17 = {
  key: 0,
  class: "d-flex justify-content-end align-items-center"
}
const _hoisted_18 = ["onClick"]
const _hoisted_19 = ["onClick"]
const _hoisted_20 = {
  key: 0,
  class: "row"
}
const _hoisted_21 = { class: "col-12 mt-3" }
const _hoisted_22 = {
  class: "alert alert-success alert-dismissible fade show",
  role: "alert"
}
const _hoisted_23 = {
  key: 1,
  class: "row"
}
const _hoisted_24 = {
  key: 2,
  class: "row"
}
const _hoisted_25 = { class: "col-12 mt-3" }
const _hoisted_26 = {
  class: "alert alert-danger alert-dismissible fade show",
  role: "alert"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BillingNewModal = _resolveComponent("BillingNewModal")!
  const _component_PromoCodeModal = _resolveComponent("PromoCodeModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[9] || (_cache[9] = _createElementVNode("div", { class: "d-flex flex-wrap" }, [
      _createElementVNode("h4", { class: "flex-fill" }, "Billing Accounts"),
      _createElementVNode("div", { class: "flex-wrap d-flex align-items-baseline" }, [
        _createElementVNode("button", {
          type: "button",
          role: "button",
          "data-toggle": "modal",
          "data-target": "#modal-new-billing",
          class: "btn btn-attention btn-new-item pull-right w-100"
        }, " New Account ")
      ])
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.accounts, (acc) => {
              return (_openBlock(), _createElementBlock("a", {
                href: "javascript:void(0)",
                class: "list-group-item list-group-item-action flex-column align-items-start",
                "data-refid": acc.refid,
                onClick: ($event: any) => (_ctx.select(acc))
              }, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _cache[1] || (_cache[1] = _createElementVNode("i", { class: "fas fa-5x fa-coins d-inline-block d-sm-block m-2" }, null, -1)),
                    _createElementVNode("b", _hoisted_9, "Credit: " + _toDisplayString(acc.credit), 1)
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("h5", _hoisted_12, _toDisplayString(acc.name), 1),
                      _createElementVNode("div", _hoisted_13, [
                        _cache[3] || (_cache[3] = _createElementVNode("button", {
                          class: "btn btn-outline-secondary btn-icon btn-menu",
                          "data-toggle": "dropdown",
                          "aria-haspopup": "true",
                          "aria-expanded": "false"
                        }, [
                          _createElementVNode("i", { class: "fas fa-ellipsis-v" })
                        ], -1)),
                        _createElementVNode("div", _hoisted_14, [
                          _createElementVNode("a", {
                            class: "dropdown-item",
                            href: "#",
                            onClick: ($event: any) => (_ctx.editBilling(acc))
                          }, [...(_cache[2] || (_cache[2] = [
                            _createElementVNode("i", { class: "fa fa-lock fa-fw" }, null, -1),
                            _createTextVNode(" Edit… ", -1)
                          ]))], 8, _hoisted_15)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_16, _toDisplayString(acc.description), 1),
                    _cache[4] || (_cache[4] = _createElementVNode("div", { class: "flex-fill" }, null, -1)),
                    (_ctx.isEnabled)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                          _createElementVNode("button", {
                            class: "btn btn-neutral-outline btn-sm mr-2",
                            onClick: ($event: any) => (_ctx.onPromoClick(acc))
                          }, "Promo Code", 8, _hoisted_18),
                          _createElementVNode("button", {
                            class: "btn btn-attention-outline btn-sm",
                            onClick: ($event: any) => (_ctx.onTopupClick(acc))
                          }, "Top Up Credit", 8, _hoisted_19)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                (_ctx.promoAccountRefid === acc.refid && _ctx.isPromoSuccess)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                      _createElementVNode("div", _hoisted_21, [
                        _createElementVNode("div", _hoisted_22, [
                          _createElementVNode("p", null, _toDisplayString(_ctx.promoSuccessMessage), 1),
                          _createElementVNode("button", {
                            type: "button",
                            class: "close",
                            "data-dismiss": "alert",
                            "aria-label": "Close",
                            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isPromoSuccess = false))
                          }, [...(_cache[5] || (_cache[5] = [
                            _createElementVNode("span", { "aria-hidden": "true" }, "×", -1)
                          ]))])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.isPaymentSuccess)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_23, [...(_cache[6] || (_cache[6] = [
                      _createElementVNode("div", { class: "col-12 mt-3" }, [
                        _createElementVNode("div", {
                          class: "alert alert-success alert-dismissible fade show",
                          role: "alert"
                        }, [
                          _createElementVNode("p", null, "Your payment was successful, and the purchased credit has been added to your account."),
                          _createElementVNode("button", {
                            type: "button",
                            class: "close",
                            "data-dismiss": "alert",
                            "aria-label": "Close"
                          }, [
                            _createElementVNode("span", { "aria-hidden": "true" }, "×")
                          ])
                        ])
                      ], -1)
                    ]))]))
                  : _createCommentVNode("", true),
                (_ctx.isPaymentError)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                      _createElementVNode("div", _hoisted_25, [
                        _createElementVNode("div", _hoisted_26, [
                          _createElementVNode("p", null, _toDisplayString(_ctx.paymentErrorMessage), 1),
                          _cache[7] || (_cache[7] = _createElementVNode("button", {
                            type: "button",
                            class: "close",
                            "data-dismiss": "alert",
                            "aria-label": "Close"
                          }, [
                            _createElementVNode("span", { "aria-hidden": "true" }, "×")
                          ], -1)),
                          _cache[8] || (_cache[8] = _createElementVNode("p", null, [
                            _createTextVNode("Please "),
                            _createElementVNode("a", {
                              target: "_blank",
                              href: "/about/contacts"
                            }, "contact us"),
                            _createTextVNode(" to resolve this issue. Thanks for your patience!")
                          ], -1))
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ], 8, _hoisted_6))
            }), 256))
          ])
        ])
      ])
    ]),
    _createVNode(_component_BillingNewModal, {
      ref: "modal",
      "dashboard-refresh": _ctx.loadBillingAccounts
    }, null, 8, ["dashboard-refresh"]),
    _createVNode(_component_PromoCodeModal, {
      ref: "promoModal",
      "on-success": _ctx.onPromoSuccess
    }, null, 8, ["on-success"])
  ]))
}